import {useAuth} from 'react-oidc-context';
import store from '@/store/store.js';
import {clearCurrentUser, setCurrentUserLoading} from '@/store/slices/authSlice.js';
import client from '@/services/apolloClient';

export const useLogout = () => {
    const auth = useAuth();

    const logout = async () => {

        console.log('🔓 Start logout process...');

        try {
            await client.clearStore();

            store.dispatch(clearCurrentUser());
            store.dispatch(setCurrentUserLoading(true));

            await auth.signoutRedirect({
                post_logout_redirect_uri: window.location.origin
            });

            console.log('🔓 Logout successful');
        } catch (error) {
            console.error('🔓🚨 Logout error:', error);
        }
    };

    return { logout };
};
